module.exports = __webpack_public_path__ + "img/facebook.18f06c79.png";